const num = (v) => Number(v) || 0;

export function toHeadcountSeries(departments) {
  const rows = Array.isArray(departments) ? departments : [];
  return {
    labels: rows.map((d) => d.departmentName),
    counts: rows.map((d) => num(d.count)),
  };
}

export function toEmployeeStatusSeries(statuses) {
  const rows = Array.isArray(statuses) ? statuses : [];
  return {
    labels: rows.map((s) => s.status),
    counts: rows.map((s) => num(s.count)),
  };
}

export function toPayrollTrendSeries(months) {
  const rows = Array.isArray(months) ? months : [];
  return {
    labels: rows.map((m) => m.month),
    gross: rows.map((m) => num(m.gross)),
    net: rows.map((m) => num(m.net)),
    tax: rows.map((m) => num(m.tax)),
  };
}

export function toRecruitmentFunnelSeries(stages) {
  const rows = Array.isArray(stages) ? stages : [];
  return {
    labels: rows.map((s) => s.stage),
    counts: rows.map((s) => num(s.count)),
  };
}
